import React from 'react';
import { Icon } from '../Icon.js';
export const ChevronLeftIcon = () => (React.createElement(Icon, null,
    React.createElement("polyline", { points: "15 18 9 12 15 6" })));
export const ChevronRightIcon = () => (React.createElement(Icon, null,
    React.createElement("polyline", { points: "9 18 15 12 9 6" })));
export const ChevronDownIcon = () => (React.createElement(Icon, null,
    React.createElement("polyline", { points: "6 9 12 15 18 9" })));
export const FolderIcon = () => (React.createElement(Icon, null,
    React.createElement("path", { d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" })));
export const XIcon = () => (React.createElement(Icon, null,
    React.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
    React.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })));
export const XCircleIcon = () => (React.createElement(Icon, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("line", { x1: "15", y1: "9", x2: "9", y2: "15" }),
    React.createElement("line", { x1: "9", y1: "9", x2: "15", y2: "15" })));
export const MaximizeIcon = () => (React.createElement(Icon, null,
    React.createElement("path", { d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" })));
export const SmartphoneIcon = () => (React.createElement(Icon, null,
    React.createElement("rect", { x: "5", y: "2", width: "14", height: "20", rx: "2", ry: "2" }),
    React.createElement("line", { x1: "12", y1: "18", x2: "12", y2: "18" })));
export const Minimize2Icon = () => (React.createElement(Icon, null,
    React.createElement("polyline", { points: "4 14 10 14 10 20" }),
    React.createElement("polyline", { points: "20 10 14 10 14 4" }),
    React.createElement("line", { x1: "14", y1: "10", x2: "21", y2: "3" }),
    React.createElement("line", { x1: "3", y1: "21", x2: "10", y2: "14" })));
export const RefreshCwIcon = () => (React.createElement(Icon, null,
    React.createElement("polyline", { points: "23 4 23 10 17 10" }),
    React.createElement("polyline", { points: "1 20 1 14 7 14" }),
    React.createElement("path", { d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" })));
export const RefreshCcwIcon = (props) => (React.createElement(Icon, { ...props },
    React.createElement("polyline", { points: "1 4 1 10 7 10" }),
    React.createElement("polyline", { points: "23 20 23 14 17 14" }),
    React.createElement("path", { d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" })));
export const HomeIcon = () => (React.createElement(Icon, null,
    React.createElement("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
    React.createElement("polyline", { points: "9 22 9 12 15 12 15 22" })));
export const CastIcon = () => (React.createElement(Icon, null,
    React.createElement("path", { d: "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6" }),
    React.createElement("line", { x1: "2", y1: "20", x2: "2", y2: "20" })));
export const EditIcon = () => (React.createElement(Icon, null,
    React.createElement("path", { d: "M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34" }),
    React.createElement("polygon", { points: "18 2 22 6 12 16 8 16 8 12 18 2" })));
export const CheckCircleIcon = (props) => (React.createElement(Icon, { ...props },
    React.createElement("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
    React.createElement("polyline", { points: "22 4 12 14.01 9 11.01" })));
export const AlertCircleIcon = () => (React.createElement(Icon, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
    React.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "16" })));
export const InfoIcon = () => (React.createElement(Icon, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "12" }),
    React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "8" })));
export const LoaderIcon = () => (React.createElement(Icon, null,
    React.createElement("line", { x1: "12", y1: "2", x2: "12", y2: "6" }),
    React.createElement("line", { x1: "12", y1: "18", x2: "12", y2: "22" }),
    React.createElement("line", { x1: "4.93", y1: "4.93", x2: "7.76", y2: "7.76" }),
    React.createElement("line", { x1: "16.24", y1: "16.24", x2: "19.07", y2: "19.07" }),
    React.createElement("line", { x1: "2", y1: "12", x2: "6", y2: "12" }),
    React.createElement("line", { x1: "18", y1: "12", x2: "22", y2: "12" }),
    React.createElement("line", { x1: "4.93", y1: "19.07", x2: "7.76", y2: "16.24" }),
    React.createElement("line", { x1: "16.24", y1: "7.76", x2: "19.07", y2: "4.93" })));
export const SlidersIcon = () => (React.createElement(Icon, null,
    React.createElement("line", { x1: "4", y1: "21", x2: "4", y2: "14" }),
    React.createElement("line", { x1: "4", y1: "10", x2: "4", y2: "3" }),
    React.createElement("line", { x1: "12", y1: "21", x2: "12", y2: "12" }),
    React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "3" }),
    React.createElement("line", { x1: "20", y1: "21", x2: "20", y2: "16" }),
    React.createElement("line", { x1: "20", y1: "12", x2: "20", y2: "3" }),
    React.createElement("line", { x1: "1", y1: "14", x2: "7", y2: "14" }),
    React.createElement("line", { x1: "9", y1: "8", x2: "15", y2: "8" }),
    React.createElement("line", { x1: "17", y1: "16", x2: "23", y2: "16" })));
export const CopyIcon = () => (React.createElement(Icon, null,
    React.createElement("rect", { x: "9", y: "9", width: "13", height: "13", rx: "2", ry: "2" }),
    React.createElement("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" })));
export const RotateCcwIcon = () => (React.createElement(Icon, null,
    React.createElement("polyline", { points: "1 4 1 10 7 10" }),
    React.createElement("path", { d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10" })));
export const FileIcon = () => (React.createElement(Icon, null,
    React.createElement("path", { d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" }),
    React.createElement("polyline", { points: "13 2 13 9 20 9" })));
export const SearchIcon = () => (React.createElement(Icon, null,
    React.createElement("circle", { cx: "11", cy: "11", r: "8" }),
    React.createElement("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })));
export const MenuIcon = () => (React.createElement(Icon, null,
    React.createElement("line", { x1: "3", y1: "12", x2: "21", y2: "12" }),
    React.createElement("line", { x1: "3", y1: "6", x2: "21", y2: "6" }),
    React.createElement("line", { x1: "3", y1: "18", x2: "21", y2: "18" })));
export const ExternalIcon = () => (React.createElement(Icon, null,
    React.createElement("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
    React.createElement("polyline", { points: "15 3 21 3 21 9" }),
    React.createElement("line", { x1: "10", y1: "14", x2: "21", y2: "3" })));
export const HelpCircleIcon = () => (React.createElement(Icon, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }),
    React.createElement("line", { x1: "12", y1: "17", x2: "12", y2: "17" })));
export const MinusSquareIcon = () => (React.createElement(Icon, null,
    React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", ry: "2" }),
    React.createElement("line", { x1: "8", y1: "12", x2: "16", y2: "12" })));
export const PlusSquareIcon = () => (React.createElement(Icon, null,
    React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", ry: "2" }),
    React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "16" }),
    React.createElement("line", { x1: "8", y1: "12", x2: "16", y2: "12" })));
export const StarIcon = () => (React.createElement(Icon, null,
    React.createElement("polygon", { points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" })));
